import { GridHelper } from 'components/Grids/GridHelper';
import {
  GeneralCellRenderer,
  BatchFormActionsCellRenderer,
  CustomerLinkCellRenderer
} from 'components/Grids/CellRenderers';

export default class BatchFormsColumnDefinitions {
  static createColDefs() {
    const columnDefs = [
      {
        headerName: 'Customer ID',
        field: 'customerId',
        cellRendererFramework: CustomerLinkCellRenderer,
        minWidth: 100,
        width: 150,
        filter: 'text',
        filterParams: { apply: true }
      },
      {
        headerName: 'Customer Name',
        field: 'customerName',
        cellRendererFramework: GeneralCellRenderer,
        minWidth: 100,
        width: 150,
        filter: 'text',
        filterParams: { apply: true }
      },
      {
        headerName: 'Line One Name',
        field: 'entityName',
        cellRendererFramework: GeneralCellRenderer,
        minWidth: 100,
        width: 150,
        filter: 'text',
        filterParams: { apply: true }
      },
      {
        headerName: 'Customer Country',
        field: 'customerPermanentAddressCountry',
        cellRendererFramework: GeneralCellRenderer,
        minWidth: 100,
        width: 150,
        filter: 'text',
        filterParams: { apply: true }
      },
      {
        headerName: 'Legal Entity',
        field: 'legalEntity',
        cellRendererFramework: GeneralCellRenderer,
        minWidth: 100,
        width: 150,
        filter: 'text',
        filterParams: { apply: true }
      },
      {
        headerName: 'Form Type',
        field: 'formTypeDescription',
        cellRendererFramework: GeneralCellRenderer,
        minWidth: 100,
        width: 150,
        filter: 'text',
        filterParams: { apply: true }
      },
      {
        headerName: 'Form Validity',
        field: 'valid',
        cellClass: 'center-aligned',
        cellRendererFramework: GeneralCellRenderer,
        valueGetter: ({
          data: { valid }
        }) => {
          if (valid === null || valid === 'undefined') {
            return 'Not Validated';
          }
          return valid ? 'Valid' : 'Rejected';
        },
        minWidth: 70,
        width: 120,
        filter: 'text',
        filterParams: { apply: true }
      },
      { headerName: 'Workflow Status',
        field: 'workflowStatus',
        cellRendererFramework: GeneralCellRenderer,
        minWidth: 120,
        width: 120,
        filter: 'text'
      },
      {
        headerName: 'Original File Name',
        field: 'originalFileName',
        cellRendererFramework: GeneralCellRenderer,
        minWidth: 100,
        width: 150,
        filter: 'text',
        filterParams: { apply: true }
      },
      {
        headerName: 'Upload Date',
        field: 'dateUploaded',
        cellRendererFramework: GeneralCellRenderer,
        valueGetter: ({
          data: { dateUploaded }
        }) => GridHelper.dateFormatter(dateUploaded, 'MMM DD, YYYY HH:mm:ss'),
        minWidth: 95,
        width: 145,
        filter: 'text',
        filterParams: { apply: true }
      },
      {
        headerName: 'View / Action',
        cellClass: 'center-aligned form-action-btns',
        field: 'id',
        cellRendererFramework: BatchFormActionsCellRenderer,
        minWidth: 70,
        width: 115,
        filter: false
      }
    ];

    return columnDefs;
  }
}
